import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';

import {
  callAPIMiddleware,
  modelMiddleware,
  analyticsMiddleware
} from './middleware';
import rootReducer from './reducers';

const withMiddleWare = applyMiddleware(
  callAPIMiddleware,
  modelMiddleware,
  analyticsMiddleware
);

const devToolsEnable =
  process.env.isDev ||
  process.env.APP_ENV === 'staging' ||
  process.env.ENVIRONMENT === 'gamma';

const withDevTools = devToolsEnable
  ? composeWithDevTools(withMiddleWare)
  : withMiddleWare;

const initStore = (initialState) => {
  return createStore(rootReducer, initialState, withDevTools);
};

export default initStore;
